<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Amministrazione Trasparente', route: '/backoffice/amministrazione-trasparente/' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">AMMINISTRAZIONE TRASPARENTE</h1>
</section>

<section class="pb-16 mb-8 px-container">

    <div class="row w-full flex lg:justify-end">
        <button class="p-3 lg:w-1/4 w-full btn-outln mb-8 text-center" type="button" routerLink="/backoffice/amministrazione-trasparente/add">                
            <i class="bi bi-plus"></i>
            Aggiungi file
        </button>
    </div>   
        
    <p-table #dt [loading]="loading" [value]="files" responsiveLayout="stack" [breakpoint]="'960px'" styleClass="p-datatable-striped" [paginator]="true" [showCurrentPageReport]="true" [rowHover]="true" [globalFilterFields]="['titolo','categoria']" currentPageReportTemplate="{first} di {last} su {totalRecords} files amministrazione trasparente" [rows]="5" [rowsPerPageOptions]="[5, 10, 20, 50]">            
        <ng-template pTemplate="caption">
            <span class="block lg:w-1/4 w-full p-input-icon-left">
                <i class="bi bi-search before:align-super before:content-['\f52a']"></i>
                <input pInputText type="text" (input)="onGlobalFilter(dt, $event)" placeholder="Cerca..." class="w-full indent-6" />
            </span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="categoria" class="w-1/4">Categoria <span class="inline-flex"><p-sortIcon field="categoria" /></span></th>                    
                <th pSortableColumn="titolo" class="w-2/4">Titolo <span class="inline-flex"><p-sortIcon field="titolo" /></span></th>                    
                <th class="w-1/4 text-center">Azioni</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-file>
            <tr>
                <td><span class="p-column-title">Categoria</span>{{file.categoria.replace('_', ' ') | titlecase}}</td>
                <td><span class="p-column-title">Titolo</span>{{file.titolo}}</td>                    
                <td class="md:justify-center justify-between flex">
                    <span class="p-column-title">Azioni</span>                    

                    <div class="flex flex-row items-center justify-center">                                    
                        <i class="bi bi-pencil lg:text-3xl text-2xl hover:text-accent cursor-pointer" [routerLink]="'/backoffice/amministrazione-trasparente/' + file.id"></i>                        
                        <p-divider layout="vertical"></p-divider>
                        <p-confirmPopup #deleteFile>
                            <ng-template pTemplate="headless" let-message>
                                <div class="border-round p-3">
                                    <span class="text-base">{{ message.message }}</span>
                                    <div class="flex align-items-center gap-2 mt-3">                                        
                                        <button type="button" class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDeleteFile()">Elimina</button>
                                        <button type="button" class="text-center btn-outln-backoffice p-2 w-full font-medium"  (click)="onAnnullaDeleteFile()">Annulla</button>
                                    </div>
                                </div>
                            </ng-template>
                        </p-confirmPopup>

                        <i class="bi bi-trash lg:text-3xl text-2xl hover:text-accent cursor-pointer" (click)="onOpenDeleteFile($event, file)" ></i>
                    </div>                    
                </td>                    
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="3">Nessun file trovato.</td>
            </tr>
        </ng-template>
    </p-table>
</section>